// 需要隐藏导航条的页面路径配置
export const HIDE_NAV_PATHS = [
  '/payment-checkout',
  // 可以在这里添加其他需要隐藏导航条的页面路径
];

export const shouldHideNav = (pathname: string) => {
  return HIDE_NAV_PATHS.includes(pathname) || pathname.startsWith('/agent/share/');
};